import * as Sentry from '@sentry/browser';
import { useCookies } from 'react-cookie';

import {
  PropertyCharacteristicListItem,
  SupportPropertyCharacteristics,
} from '@type-def_iqfu/PropertyCharacteristicsType';

const backendBasePath = process.env.NEXT_PUBLIC_DEV_BACKEND_URL;

export type UpdateGeneralAgencyPayload = {
  property_type_ids?: number[];
  property_characteristic_ids?: number[];
};

export type GeneralAgencyUserType = 'admin' | 'company';

type GeneralAgencyInfo = {
  company_id: number;
  support_property_types: PropertyCharacteristicListItem[];
  support_property_characteristics: SupportPropertyCharacteristics;
};

const buildBasePath = (userType: GeneralAgencyUserType, company_id: string) => {
  const namespace = userType === 'admin' ? 'admin' : 'company';
  return `${backendBasePath}/${namespace}/companies/${company_id}/general_agency_detail`;
};

export const useGeneralAgency = (userType: GeneralAgencyUserType = 'admin') => {
  const [cookies] = useCookies(['expiry', 'access-token', 'client', 'uid', 'user-type']);

  const getGeneralAgencyInfo = async (company_id: string): Promise<GeneralAgencyInfo | undefined> => {
    const url = buildBasePath(userType, company_id);

    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        uid: cookies['uid'],
        client: cookies['client'],
        'access-token': cookies['access-token'],
      },
    })
      .then((response) => response.json())
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
        return undefined;
      });
  };

  const updateGeneralAgencyInfo = async (
    payload: UpdateGeneralAgencyPayload,
    company_id: string,
  ): Promise<{ success: boolean } | undefined> => {
    const url = buildBasePath(userType, company_id);

    return fetch(url, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        uid: cookies['uid'],
        client: cookies['client'],
        'access-token': cookies['access-token'],
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
        return undefined;
      });
  };

  return {
    getGeneralAgencyInfo,
    updateGeneralAgencyInfo,
  };
};
